module.exports = __webpack_public_path__ + "img/ios-log-out.64666e40.svg";